import React, { useRef, useState } from 'react'
import { motion, AnimatePresence, delay } from 'framer-motion'
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@nextui-org/react";
import { Button, ButtonGroup } from "@nextui-org/react";
import { Avatar } from "@nextui-org/react";
import './PortalComponents.css'
import { Input } from "@nextui-org/react";
import {Select, SelectItem} from "@nextui-org/react";
import BackEndUrl from '../../backURL';
import { Slider } from "@nextui-org/react";
import { Toast } from 'primereact/toast';
const backend = BackEndUrl.domain

const relationshipsList = [
  { key: "wife", label: "Wife" },
  { key: "husband", label: "Husband" },
  { key: "mother", label: "Mother" },
  { key: "father", label: "Father" },
  { key: "sister", label: "Sister" },
  { key: "brother", label: "Brother" },
  { key: "son", label: "Son" },
  { key: "daughter", label: "Daughter" },
  { key: "grandmother", label: "Grandmother" },
  { key: "grandfather", label: "Grandfather" },
  { key: "aunt", label: "Aunt" },
  { key: "uncle", label: "Uncle" },
  { key: "cousin", label: "Cousin" },
  { key: "niece", label: "Niece" },
  { key: "nephew", label: "Nephew" },
  { key: "godfather", label: "Godfather" },
  { key: "godmother", label: "Godmother" },
  { key: "friend", label: "Friend" },
  { key: "colleague", label: "Colleague" },
  { key: "mentor", label: "Mentor" },
  // Add more relationships as needed
];


const PortalComponents = ({ type, profpic, ...rest }) => {
  const [selectedOption, setSelectedOption] = React.useState(new Set(["merge"]));
  const toast = useRef(null);
  const selectedOptionValue = Array.from(selectedOption)[0];
  const [nicValue, setNicValue] = useState("")
  function isEmpty(obj) {
    if (obj === null || obj === undefined) {
      return true; // Treat null and undefined as empty
    }
  }
  const handleInputChange = (type, event) => {
    var inputValue = event.target.value;

    let filteredValue = "";

    switch (type) {
      case "number":
        filteredValue = inputValue?.replace(/[^0-9]/g, '');

        break;
      case "alpha":
        filteredValue = inputValue?.replace(/[^a-zA-Z\s]/g, '')
        break;
      case "email":
        filteredValue = inputValue?.replace(/[^a-zA-Z0-9._@-]/g, '');
        break;
      case "address":
     
        filteredValue = inputValue.replace(/[^a-zA-Z0-9.,\s\/-]/g, '');
        break;
      case "nic":
          inputValue=inputValue?.toUpperCase()
          const oneBeforeLastChar = inputValue.slice(-2, -1);

          if (inputValue.length < 10) {
            // Filter the input to allow only numbers, 'X', 'V', 'x', and 'v'
            filteredValue = inputValue.replace(/[^0-9]/g, '');
            setNicValue(filteredValue);
          } else if (inputValue.length === 10 && (inputValue.endsWith('X') || inputValue.endsWith('V'))) {
            // If the length is 10 and ends with 'X' or 'V', update the state with the original input
            setNicValue(inputValue);
            filteredValue = inputValue;
          } else if (inputValue.length < 12 && (oneBeforeLastChar !== "X" && oneBeforeLastChar !== "V")) {
            // Filter the input to allow only numbers, 'X', 'V', 'x', and 'v'
            filteredValue = inputValue.replace(/[^0-9XVxv]/g, '');
            setNicValue(filteredValue);
          } else if (inputValue.length === 12 && /^\d+$/.test(inputValue)) {
            // If the length is 12 and consists of only digits, update the state with the original input
            setNicValue(inputValue);
            filteredValue = inputValue;
          } else {
            // If none of the conditions are met, show an error toast
            setNicValue((prev)=>prev);
            filteredValue = nicValue;
          
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'Invalid NIC',
              description: "Please enter a valid NIC",
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                  <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                  <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                </div>
              ),
            });
          }
          break;


      case "alpha-num":
        filteredValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
        break;
      default:
        filteredValue = inputValue;
    }

    if (rest.formik) {
      rest.formik.setFieldValue(rest.name, filteredValue);
    }
  };

  switch (type) {
    case "dropdown":

      return (
        <Dropdown>
          <DropdownTrigger>
            <Button
              variant="bordered"
            >
              Open Menu
            </Button>
          </DropdownTrigger>
          <DropdownMenu aria-label="Dynamic Actions" items={rest.items}>
            {(item) => (
              <DropdownItem
                key={item.key}
                color={item.key === "delete" ? "danger" : "default"}
                className={item.key === "delete" ? "text-danger" : ""}
              >
                {item.label}
              </DropdownItem>
            )}
          </DropdownMenu>
        </Dropdown>
      );
    case "avatar-dropdown":
      return (
        <ButtonGroup variant="flat" className='avatar-dropdown-con'>
          <Button className='avatar-dropdown'>

            <Avatar className='avatar-image' src={profpic} size="md" />
            <div>{rest.cusName}</div>

          </Button>


          {rest.children}

        </ButtonGroup>

      )
    case "link-dropdown":
      return (
        <ButtonGroup variant="flat" className='link-dropdown-con'>
          <Button className='avatar-dropdown link-dropdown' >


            <div>{rest.cusName}</div>

          </Button>
          <Dropdown placement="bottom-end">
            <DropdownTrigger className='avatar-dropdown'>
              <Button isIconOnly>
                <svg fill="none" height="14" viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.9188 8.17969H11.6888H6.07877C5.11877 8.17969 4.63877 9.33969 5.31877 10.0197L10.4988 15.1997C11.3288 16.0297 12.6788 16.0297 13.5088 15.1997L15.4788 13.2297L18.6888 10.0197C19.3588 9.33969 18.8788 8.17969 17.9188 8.17969Z" fill="currentColor" />
                </svg>
              </Button>
            </DropdownTrigger>
            <DropdownMenu

              aria-label="Merge options"

              selectionMode="single"

              className="max-w-[300px] "
            >

              {rest.menuList && rest.menuList.map((value, index) => {

                if (!(value.policy_number == rest.seletedPolicy)) {
                  return (

                    <DropdownItem key={`key_policy_slect_${index}`} description={rest.desc} href={`/customer-portal?policy-id=${value.policy_number}`}>

                      {value.policy_number}
                    </DropdownItem>

                  )
                }



              })}



            </DropdownMenu>
          </Dropdown>
        </ButtonGroup>

      )
    case "input":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={rest.onchange}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} />
        </div>
      )
    case "input-name":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("alpha", e) }}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} />
        </div>
      )
      case "input-relationship":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

        <Select
                label={rest.label}
                placeholder="Select a relationship"
                className="max-w-xs"
                name={rest.name}
                defaultSelectedKeys={rest.value && [rest.value.toLowerCase()]}
                value={rest.value}
                onChange={(e) => handleInputChange("alpha", e)}
                isDisabled={rest.isDisabled}
                // disabled={rest.isDisabled}
            >
                {relationshipsList.map((relationship) => (
              <SelectItem key={relationship.key}>
                {relationship.label}
              </SelectItem>
            ))}
            </Select>
        </div>
      )



    case "input-email":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("email", e) }}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} />
        </div>
      )
    case "input-nic":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">
          <Toast ref={toast} position="top-center" />

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("nic", e) }}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} />
        </div>
      )


    case "input-number":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("number", e) }}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} onBlur={rest.onBlur} />
        </div>
      )
      case "input-number-group":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("number", e) }} readOnly={rest.readOnly}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} endContent={rest.endContent} />
        </div>
      )
    case "input-address":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3"  >

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("address", e) }}
            errorMessage={rest.errors} isDisabled={rest.isDisabled} />
        </div>
      )
    case "input-alphanum":

      return (

        <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3">

          <Input type="text" label={rest.label} name={rest.name} value={rest.value} onChange={(e) => { handleInputChange("alpha-num", e) }}
            errorMessage={rest.errors} isDisabled={rest.isDisabled}  />
        </div>
      )
    case "slider":

      return (
        <div style={{ width: "100%" }} className='d-flex justify-content-center flex-column'>
          <div className="flex w-full flex-wrap md:flex-nowrap gap-4 my-3 d-flex justify-content-left ">



            <Slider label={rest.label}
              color="foreground"
              size="sm"
              step={1}
              name={rest.name}
              onChange={rest.onchange}
              value={rest.value}

              className="max-w-md"
              style={{ width: "100%" }}
            />


          </div>
          <p className='d-flex justify-content-center'><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
        </div>
      )
      

  }

}

export default PortalComponents
